/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 14.06.25
 *
 */
import DbBaseObject from "@shared/DbBaseObject";
import TimeIntervalSimple from "@shared/scheduler/TimeIntervalSimple";
import {Type} from "@qwoach/class-transformer-wrapper";

export default class ExceptionDatesItem extends DbBaseObject {

	// requires internal cleanup logic to delete old items.
	// for example, if date is in the past and no active commissions that is affected by that date, the item should be deleted
	// otherwise, it will grow indefinitely and we'll hit limit of 1Mb per document in Firestore
	@Type(() => TimeIntervalSimple)
	exceptionTimeIntervals: TimeIntervalSimple[] = [];

	constructor() {
		super();
	}

	getExceptionTimeIntervals(){
		return this.exceptionTimeIntervals
	}
	setExceptionTimeIntervals(intervals){
		this.exceptionTimeIntervals = intervals
	}
	hasExceptionTimeIntervals(){
		return this.exceptionTimeIntervals.length > 0
	}
	addExceptionTimeInterval(timeInterval){
		this.exceptionTimeIntervals.pushUnique(timeInterval, ti => ti.id === timeInterval.id)
	}
	setExceptionTimeInterval(timeInterval){
		let index = this.exceptionTimeIntervals.findIndex(ti => ti.id === timeInterval.id)
		if(index >= 0){
			this.exceptionTimeIntervals[index] = timeInterval
			return true
		}
		return false
	}
	removeExceptionTimeInterval(timeInterval){
		return this.exceptionTimeIntervals.deleteItem(ti => ti.id === timeInterval.id)
	}


}
